import { createIcon } from '../createIcon';

export const ChevronDownIconConfig = {
  name: 'ChevronDownIcon',
  height: 512,
  width: 512,
  svgPath: 'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z',
  yOffset: 0,
  xOffset: 0
};

export const ChevronDownIcon = createIcon(ChevronDownIconConfig);

export default ChevronDownIcon;